import type { SVGProps } from "react";

export function IconVideoVolumeMuted(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      height="19"
      viewBox="0 0 19 19"
      width="19"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Video volume muted</title>
      <path
        d="M8.414 3.824L4.59 6.883H1.531v4.589H4.59l3.824 3.059V3.824z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        stroke="white"
        strokeLinecap="round"
        strokeWidth="1.5"
        x1="12"
        x2="17.5"
        y1="5.5"
        y2="13"
      />
      <line
        stroke="white"
        strokeLinecap="round"
        strokeWidth="1.5"
        x1="17.5"
        x2="12"
        y1="5.5"
        y2="13"
      />
    </svg>
  );
}
